<template>
  <div class="horizon-container">
    <div id="moveLeft" class="h-100 flex-column bg-ff" style="width: 200px">
      <div class="left-top">
        <div class="flex-1 font-16-30313a">提交按钮</div>
      </div>
      <div class="flex-1 h-0" v-if="menuList">
        <cate-menu :menu-data="menuList" :not-operate="true" @on-choose="onChooseMenu" :choose-id="chooseMenuId"></cate-menu>
      </div>
    </div>
    <move-horizon></move-horizon>
    <div class="flex-1 w-0">
      <div style="padding: 10px 20px 20px 0" class="flex-column h-100">
        <div class="flex content-top mb-10">
          <div class="flex-1 bg-ff h-100 flex align-center pl-10 ptb-5">
            <div class="flex align-center mr-20 cursor">
              <div class="mr-5 decoration-line" ></div>
              <div class="font-bold font-16-f5971d" >选择部门</div>
            </div>
          </div>
        </div>
        <div class="bg-ff font-12-ff5555 text-left align-center ptb-8 border-b-e2 pl-20">
          <i class="el-icon-warning mr-5"></i>
          提示：请为按钮“{{currentMenu.name}}”勾选要提交的部门，可多选
        </div>
        <div class="flex-1" style="border-radius: 10px">
          <div class="h-100 flex-column bg-ff">
            <div class="flex-1 h-0">
              <div class="h-100 plr-20">
                <el-scrollbar class="h-100 hide-x">
                  <template v-for="(item, index) in dataList">
                    <normal-menu :menu-data="item" :index="index" :not-flex="true" :key="index" :type="0" :step="0" @on-checked="onCheckDept"></normal-menu>
                  </template>
                </el-scrollbar>
              </div>
            </div>
            <div style="height: 50px; border-top: 1px solid #e2e2e2" class="flex align-center justify-center">
              <div class="btn-30-border-85 mr-10" @click="getData">重置</div>
              <div class="btn-30-bg-f5971d-s" @click="onSave">保存</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CateMenu from '../../components/CateMenu'
import MoveHorizon from '../../components/MoveHorizon'
import NormalMenu from '../../components/NormalMenu'
export default {
  name: 'departmentAssignDefine',
  components: {NormalMenu, CateMenu, MoveHorizon},
  data () {
    return {
      chooseMenuId: 'submitSalesman',
      currentMenu: {
        name: '提交业务员',
        id: 'submitSalesman'
      },
      menuList: [
        {
          name: '提交业务员',
          id: 'submitSalesman'
        }, {
          name: '提交设计师',
          id: 'submitDesigner'
        }, {
          name: '提交客户经理',
          id: 'submitCm'
        }, {
          name: '提交预算员',
          id: 'submitBe'
        }, {
          name: '提交项目经理',
          id: 'submitPm'
        }, {
          name: '提交工程监理',
          id: 'submitSu'
        }, {
          name: '提交售后服务',
          id: 'submitAs'
        }, {
          name: '提交飞单管理',
          id: 'submitFail'
        }
      ],
      dataList: []
    }
  },
  created () {
    this.getData()
  },
  mounted () {},
  methods: {
    onSave () {
      let checkedList = []
      this.getCheckedList(this.dataList, checkedList)
      this.axios.post('assignDefine/save', checkedList).then(res => {
        if (res.data.success) {
          this.$message.success('设置成功！')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getCheckedList (list, checkedList) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].isChecked) {
          let info = {
            assignKey: this.chooseMenuId,
            companyId: this.$store.state.companyId,
            departmentId: list[i].id
          }
          checkedList.push(info)
        }
        if (list[i].children && list[i].children.length) {
          this.getCheckedList(list[i].children, checkedList)
        }
      }
    },
    onCheckDept (isChecked, index, dept) {
    },
    getData () {
      this.axios.post('assignDefine/departmentList', {companyId: this.$store.state.companyId, assignKey: this.chooseMenuId}).then(res => {
        if (res.data.success) {
          this.dataList = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onChooseMenu (menu) {
      if (menu.id !== this.chooseMenuId) {
        this.chooseMenuId = menu.id
        this.currentMenu = menu
        this.getData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .left-top {
    display: flex;
    align-items: center;
    padding: 0 10px 0 20px;
    border-bottom: 1px solid #e2e2e2;
    height: 40px;
    text-align: left;
    cursor: pointer;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/departmentAssignDefine.vue